import { createDownloadChatTranscript } from "@edgetier/utilities";
import axios from "./axios";

export const downloadChatTranscript = createDownloadChatTranscript(axios);
